import { render, staticRenderFns } from "./BrandAreaComponent.vue?vue&type=template&id=95ac220c&lang=pug&"
import script from "./BrandAreaComponent.vue?vue&type=script&lang=js&"
export * from "./BrandAreaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports